export interface SubAccount {
  _id: string;
  firstName: string;
  lastName: string;
  sex: 'male' | 'female';
  birthday: string;
  phoneNumbers: Array<{
    countryCode: string;
    number: string;
    type: string;
    isPrimary: boolean;
  }>;
  accountType: string;
  email?: string;
  passportNumber?: string;
}

export interface SubAccountsState {
  subAccounts: SubAccount[];
  loading: boolean;
  error: string | null;
}

export const initialSubAccountsState: SubAccountsState = {
  subAccounts: [],
  loading: false,
  error: null,
};
